import React, { ReactNode } from "react";
import { Patient } from "../../../system/AppState/AppPatientsState";
import Flex from "../../Generic/Flex";
import PatientAvatar from "../../PatientAvatar/PatientAvatar";

interface Props {
  patient: Patient;
  monthPicker: ReactNode;
}

const PatientVisitsAndTasksExtraHeader = (props: Props) => {
  return (
    <Flex
      className="PatientVisitsAndTasksExtraHeader"
      yGap={8}
      direction="column"
      alignItems="center"
    >
      <Flex className="__wrapper" xGap={8}>
        <PatientAvatar initials={props.patient.initials} />
        <div>
          <span className="__patientName">{props.patient.fullName}</span>
          <span className="__patientAddress">{props.patient.address}</span>
        </div>
      </Flex>

      <div style={{ alignSelf: "stretch" }}>{props.monthPicker}</div>
    </Flex>
  );
};

export default React.memo(PatientVisitsAndTasksExtraHeader);
